export const parseMavenCommand = (script: string) => {
  if (script.includes('\n')) {
    return null
  }
  return script.match(/^(?:mvn|\.\/mvnw)(?:\s+(.*))?$/)
}
